import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from 'App.tsx';
import { SlackAuthProvider } from 'features/auth/SlackAuthContext.tsx';

/** Data router so claim-mode can use useBlocker for in-app navigation warnings. */
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <SlackAuthProvider>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </SlackAuthProvider>
);
